import { render } from "./IconHome.vue.js?vue&type=template&id=6f657758!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconHome.vue?vue&type=template&id=6f657758"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__